import React from 'react'

const SsrContext = React.createContext({
  ssr: false
})

export default SsrContext



// WEBPACK FOOTER //
// ./assets/js/components/base/SsrContext.jsx